import { render, staticRenderFns } from "./UpdateFile.vue?vue&type=template&id=0596fab4&scoped=true&"
import script from "./UpdateFile.vue?vue&type=script&lang=js&"
export * from "./UpdateFile.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFile.vue?vue&type=style&index=0&id=0596fab4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596fab4",
  null
  
)

export default component.exports